export default __webpack_public_path__ + "static/media/box__blue-bg.a17f2584.svg";